import { BracketPickerMatch } from "components/Bracket/Pickem/BracketPickerMatch";
import { BracketNode } from "model/Bracket/BracketGraph";
import { ErrorText } from "styles/text";
import {
  BracketMatchArgs,
  isBracketMakePicksMatchArgs,
  isBracketViewPicksMatchArgs,
} from "./BracketMatchArgs";
import { BracketMatch } from "./Match/BracketMatch";
import { EmptyMatchContainer } from "./Match/styles";
import { BracketViewPickMatch } from "./UserPicks/BracketViewPickMatch";
import { selectMatch } from "selectors/Match";
import { useAppSelector } from "app/hooks";

interface Props {
  node: BracketNode;
  tournamentId: string;
  args?: BracketMatchArgs;
}

export const BracketRowMatchPlaceholder = () => {
  return <EmptyMatchContainer />;
};

// todo - should Picker distinction be done elsewhere, or more of an interface approach perhaps?
export const BracketRowMatch = ({ node, tournamentId, args }: Props) => {
  const matchId = node.match.matchId;
  const match = useAppSelector((state) => selectMatch(state, matchId));
  if (!match) {
    return (
      <EmptyMatchContainer>
        <ErrorText>Can't resolve match {node.match.matchId}</ErrorText>
      </EmptyMatchContainer>
    );
  }

  if (!!args && isBracketMakePicksMatchArgs(args)) {
    const { picks, updatePick, pickOptions } = args;
    return (
      <BracketPickerMatch
        matchId={matchId}
        tournamentId={tournamentId}
        picks={picks}
        updatePick={updatePick}
        pickOptions={pickOptions}
      />
    );
  }

  if (!!args && isBracketViewPicksMatchArgs(args)) {
    const { picks, matchPoints, pickOptions } = args;
    return (
      <BracketViewPickMatch
        matchId={matchId}
        tournamentId={tournamentId}
        picks={picks}
        matchPoints={matchPoints}
        pickOptions={pickOptions}
      />
    );
  }

  return <BracketMatch node={node} match={match} tournamentId={tournamentId} />;
};
